import _ from 'lodash';

class AttachmentHandlerHelperService {
	constructor() {}

	manageResult = (results, attachments) => {
		var failedItems = [];
		var successItems = {};
		_.each(results, (response, index) => {
			var info = attachments[index];
			if (response.data) {
				response.data.preview = window.URL.createObjectURL(response.data);
				response.data.name = info.name;
				response.data.id = info.id;
				response.data.data = info.data;
				successItems[info.data.ord] = response.data;
			}
		});

		if (failedItems.length > 0) {
			//TODO add notification failure
		}
		return Object.values(successItems);
	};

	getAttachments = (service, attachments, resource) => {
		var attachmentPromises = [];
		_.each(attachments, function(attachment) {
			attachmentPromises.push(service.getAttachment(resource.id, attachment.id));
		});
		return Promise.all(attachmentPromises);
	};

	deleteAttachments(service, attachments, id) {
		var promises = [];

		var deletedAttachments = _.map(attachments, attachment => {
			attachment.isDeleted = true;
			return attachment;
		});
		if (deletedAttachments && deletedAttachments.length > 0) {
			promises.push(service.deleteAttachments(deletedAttachments, id));
		}

		return Promise.all(promises);
	}

	updateAttachments = async (service, id, attachments) => {
		let promises = [];

		let newAttachments = _.filter(attachments, function(attachment) {
			return attachment.isNew === true;
		});
		if (newAttachments && newAttachments.length > 0) {
			promises.push(service.uploadAttachments(newAttachments, id));
		}

		let deletedAttachments = _.filter(attachments, function(attachment) {
			return attachment.isDeleted === true;
		});
		if (deletedAttachments && deletedAttachments.length > 0) {
			promises.push(service.deleteAttachments(deletedAttachments, id));
		}

		let newAttachmentsUpdateData = _.filter(attachments, function(attachment) {
			return attachment.data ? attachment.data.isNew === true : null;
		});
		if (newAttachmentsUpdateData && newAttachmentsUpdateData.length > 0) {
			// Make sure upload and deletion is done
			return Promise.all(promises).then(() => {
				service.updateAttachmentData(newAttachmentsUpdateData, id);
			});
		} else {
			return Promise.all(promises);
		}
	};

	notifyAttachmentFailures = (items, title) => {
		//TODO add notification error!
	};
}

export default AttachmentHandlerHelperService;



// WEBPACK FOOTER //
// ./src/common/data/AttachmentHandlerHelperService.js